import React from "react";
import { useTheme } from "@mui/material/styles";

const StatusFailedIcon = () => {
  const theme = useTheme();

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" r="9" fill={theme.palette.error[500]}/>
      <path d="M11.625 6.375L6.375 11.625M6.375 6.375L11.625 11.625" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default StatusFailedIcon;
